import React from 'react';
import { SettingsIcon, MailIcon } from 'lucide-react';
export function Support() {
  return <footer className="px-5 pb-12 pt-4" data-id="element-185" data-mp="1crwq1x9zqo4b">
      <div className="rounded-2xl border border-[#c9d6cd] bg-white/85 p-5 text-center backdrop-blur-sm" data-id="element-186" data-mp="1cqv59136an9e">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#e5efe7]" data-id="element-187" data-mp="xtunnqep48on">
          <SettingsIcon className="h-6 w-6 text-[#3f5d4e]" aria-hidden="true" data-id="element-188" data-mp="12va7xg91ub5z" />
        </span>
        <p className="mt-3 text-[13px] font-bold uppercase tracking-wide text-[#3f5d4e]" data-id="element-189" data-mp="p0hm602kfyqy">Soporte</p>
        <a href="mailto:EbookDreamShop@gmail.com" className="mt-1 inline-flex items-center gap-2 text-[14px] font-semibold text-[#16302a] underline decoration-[#6f8f7c] decoration-2 underline-offset-4" data-id="element-190" data-mp="tttx57ebo718">
          <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-191" data-mp="636mied0v3az" />
          EbookDreamShop@gmail.com
        </a>
        <p className="mt-3 text-[11.5px] leading-relaxed text-[#6b7b73]" data-id="element-192" data-mp="a49yuqvv2h7g">
          Escríbenos por cualquier duda sobre tu descarga o el material. Producto digital en PDF, pago único,
          entrega inmediata.
        </p>
      </div>
    </footer>;
}